// Must run before any wagmi/AppKit module is imported (import is hoisted,
// but registering this listener still happens before App's wagmi init runs
// at module evaluation time, since wagmi only listens once App is loaded).
import './utils/hideTronlinkFromEip6963';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Get Clerk publishable key from environment
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  console.error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY environment variable');
}

// Brand the Clerk widget to match the landing palette so the transition
// from /sign-in feels continuous with the rest of the site.
const clerkAppearance = {
  variables: {
    colorPrimary: '#A52668',
    colorBackground: '#14141C',
    colorText: '#F5F5F7',
    colorTextSecondary: '#9A9AA8',
    colorInputBackground: '#1B1B26',
    colorInputText: '#F5F5F7',
    colorDanger: '#FF5577',
    colorSuccess: '#1FA9D6',
    borderRadius: '12px',
    fontFamily: '"DM Sans", system-ui, -apple-system, sans-serif',
  },
  elements: {
    rootBox: { width: '100%' },
    card: {
      backgroundColor: '#14141C',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      boxShadow: '0 24px 60px rgba(0, 0, 0, 0.45)',
    },
    headerTitle: { fontFamily: '"Unbounded", sans-serif', fontWeight: 500 },
    formButtonPrimary: {
      backgroundColor: '#A52668',
      textTransform: 'none',
      fontWeight: 600,
      boxShadow: '0 8px 24px rgba(165, 38, 104, 0.35)',
    },
    formButtonPrimary__hover: { backgroundColor: '#D43B85' },
    socialButtonsBlockButton: {
      borderColor: 'rgba(255, 255, 255, 0.12)',
      color: '#F5F5F7',
    },
    footerActionLink: { color: '#4EC8F0' },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPubKey} appearance={clerkAppearance}>
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
